import { Component, Input, NgZone, OnInit, OnChanges, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { ContactService } from '../../services/contact.service';
import { SearchCarrierContact } from '../../models/models';

@Component({
    selector: 'carrier-contact-grid',
    templateUrl: './carrier-contact-grid.component.html',
    standalone: false
})
export class CarrierContactGrid implements OnInit, OnChanges {
    @Input() carrierID: number = 0;

    @ViewChild(GridComponent, { static: false }) public contactsGrid!: GridComponent;

    public contacts: SearchCarrierContact[] = [];
    public filteredContacts: SearchCarrierContact[] = [];
    public isLoading: boolean = false;
    public gridState: State = { skip: 0, take: 10, sort: [{ dir: 'desc', field: 'isDefault' }, { dir: 'asc', field: 'carrierName' }] };
    public gridData: GridDataResult = { data: [], total: 0 };

    constructor(private contactService: ContactService, private ngZone: NgZone) { }

    ngOnInit() {
        this.getCarrierContacts();
        //console.log("ngOnInit");
    }

    ngOnChanges() {
        this.getCarrierContacts();
        //console.log("ngOnChanges");
    }

    private getCarrierContacts() {
        this.isLoading = true;
        this.contactService.getSearchContactByCarrierID(this.carrierID).subscribe(result => {
            this.contacts = result.resultCollection;
            this.isLoading = false;
            this.setGrid();
            //console.log("contacts", this.contacts.length);
        });
    }

    private setGrid() {
        this.filteredContacts = Object.assign([], this.contacts);
        this.gridData = process(this.filteredContacts, this.gridState);
        //console.log("setGrid", this.gridData, this.filteredCarriers);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.contactsGrid == null) return;
            //this.contactsGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.gridState = state;
        this.gridData = process(this.contacts, this.gridState);
    }
}
